export const healthConstants = {

    GET_ALL_SUCCESS: "HEALTHS_GET_ALL_SUCCESS",
    FAILURE: "HEALTHS_FAILURE",
    REQUEST: "ALARMS_REQUEST",
};
